<template>
  <language-form
    v-model="form"
    :image-url="null"
    class="w-full bg-white"
    @submit="submit"
  >
    <div
      class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-6 py-4"
    >
      <loading-button
        :loading="form.processing"
        class="btn-indigo"
        type="submit"
      >
        Utwórz język
      </loading-button>
    </div>
  </language-form>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useForm } from '@inertiajs/vue3';
import LoadingButton from '@/Shared/LoadingButton.vue';
import LanguageForm from './Form.vue';
import { createLanguageRouteHelper } from '@/utils/createLanguageRouteHelper';

const { proxy } = getCurrentInstance();
const routes = proxy.$routes;

const form = useForm({
  language: {
    name: '',
    active: true,
    image: null,
  },
});

const languageRoutes = computed(() => createLanguageRouteHelper(null, routes));

const emit = defineEmits(['success']);

const submit = () => {
  form.post(languageRoutes.value.index(), {
    onFinish: () => {
      if (!form.hasErrors) {
        form.reset();
        form.language.active = true;
      }
    },
    onSuccess: () => {
      emit('success');
    },
    onError: () => {},
  });
};
</script>
